<!--  -->
<template>
  <div class="project_index_main">
    <!-- 面包屑 -->
    <div class="project_breadcrumb_box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>项目列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 标题 -->
    <div class="project_header_box">
      <h2>我的项目</h2>

      <p>选择项目进入绩效管理</p>
    </div>
    <!-- 列表 -->
    <div class="project_list_box">
      <div class="project_list" v-if="projectList.length > 0">
        <div
          class="project_list_item"
          v-for="(item, index) in projectList"
          :key="index"
        >
          <!--  -->
          <div class="project_list_item_header">
            <div class="project_list_item_name">{{ item.project_name }}</div>
          </div>
          <!--  -->
          <div class="project_list_item_content">
            <div class="project_list_item_info">
              <div class="project_list_item_menu">
                <p>指标总数</p>
                <h2 style="color: #3381c3">{{ item.rule_count || 0 }}</h2>
              </div>
              <!--  -->
              <div class="project_list_item_menu">
                <p>完成率</p>
                <h2 class="yellow">{{ item.overall_percent || 0 }}%</h2>
              </div>
              <!--  -->
              <div class="project_list_item_menu">
                <p>提交次数</p>
                <h2 class="green">{{ item.fill_count || 0 }}</h2>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="project_list_item_handle">
            <el-button
              class="project_list_item_detail"
              size="small"
              @click="goPerformancePage(item, index)"
            >
              查看详情
            </el-button>
          </div>
        </div>
      </div>
      <!-- 空状态 -->
      <div class="project_empty_box" v-else>
        <p>暂无项目数据</p>
      </div>

      <!-- 分页 -->
      <div class="project_page_box" v-if="pageData.total > pageData.pageSize">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageData.total"
          :page-size="pageData.pageSize"
          :current-page="pageData.pageIndex"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getModuleProjectList } from "@/api/module";

export default {
  name: "",

  data() {
    return {
      // 项目列表
      projectList: [],
      // 分页
      pageData: {
        pageIndex: 1,
        pageSize: 6,
        total: 0,
      },
      // 加载状态
      loading: false,
    };
  },

  created() {
    this.$emit("setActive", {
      active: 8,
    });

    // 获取项目列表
    this.getProjectList();
  },

  methods: {
    /**
     * 获取项目列表
     */
    async getProjectList() {
      this.loading = true;

      const res = await getModuleProjectList(
        this.pageData.pageIndex,
        this.pageData.pageSize
      );

      if (res && res.code === 200) {
        this.projectList = res.data.data || [];
        this.pageData.total = res.data.total || 0;
      }

      this.loading = false;
    },

    /**
     * 分页切换
     * @param {Number} page 页码
     */
    handlePageChange(page) {
      this.pageData.pageIndex = page;
      this.getProjectList();
    },

    /**
     * 跳转绩效管理填报页
     * @param {Object} item 项目数据
     * @param {Number} index 索引
     */
    goPerformancePage(item, index) {
      this.$router.push({
        path: "/orghome/project_performance/list",
        query: {
          projectId: item.id,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import url("index.scss");
</style>
